import { useCallback, useEffect, useState } from "react";

export interface AuthState {
  loading: boolean;
  authenticated: boolean;
  guest: boolean;
  user: { id: string; name: string } | null;
  signInUrl: string;
  refresh: () => Promise<void>;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<Omit<AuthState, "refresh">>({
    loading: true, authenticated: false, guest: false, user: null,
    signInUrl: "/helios/auth?next=%2Fsanctum%2F",
  });
  const refresh = useCallback(async () => {
    try {
      const response = await fetch("/api/occult/session", { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) throw new Error("Session unavailable");
      const value = await response.json() as Omit<AuthState, "loading" | "refresh">;
      setState({ loading: false, ...value });
    } catch {
      setState((current) => ({ ...current, loading: false, authenticated: false, user: null }));
    }
  }, []);
  useEffect(() => {
    void refresh();
    const onFocus = () => void refresh();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [refresh]);
  return { ...state, refresh };
}
